//import  baseHttp  from '@/services/baseHttp';

// initial state
// put variables and collections here
const state = () => ({
  zendeskInfo:{credentials:null,userInfo:null,user:null,ticket:null,origin:null,app_guid:null,attachments:[],linkedItems:[]},
  zdOrganization:null,
  zdTicket:null,
  zdTicket_fields:null,
  zdMetadata:null,
})

// getters
const getters = {
  getZendeskInfo(state){
    return state.zendeskInfo;
  },
  getZdTicket(state){
    return state.zdTicket;
  },
  getZdTicket_fields(state){
    return state.zdTicket_fields;
  },
  getZdOrganization(state,organization_id){
    return state.zdOrganization;
  },
  getZendeskMetadata(state){
    return state.zdMetadata;
  }
}

// actions
// put asynchronous functions that can call one or more mutation functions
//https://developer.zendesk.com/apps/docs/core-api/client_api
const actions = {
  async getZendeskMetadata(context){
    // client.metadata().then(function(metadata) {
    //   console.log(metadata);
    //   context.commit('setZendeskMetadata',metadata);
    // });
    let metadata = await client.metadata();
    context.commit('setZendeskMetadata', metadata); 
    return metadata;
  },
  async getZendeskInfo(context){
    let zendeskInfo={};
    let zendeskMetaObj=await actions.getZendeskMetadata(context);
    
    let requestType=document.location.pathname;
    requestType=requestType.startsWith('/')?requestType.substr(1,requestType.length-1):requestType;
    requestType=requestType.endsWith('/')?requestType.substr(0,requestType.length-1):requestType;
    zendeskInfo.credentials={
      //requestType:"zendesk-devops"
      requestType:requestType
    }
    
    let ticket=await client.get('ticket');
    
    zendeskInfo.ticket=ticket.ticket;
    let user=await client.get('currentUser');
    zendeskInfo.user=user.currentUser;
    //zendeskInfo.credentials.hdLoginUrl=ticket.ticket.brand.url;//racqual facing issue with this 04/03/2021
    //zendeskInfo.credentials.hdLoginUrl=ticket.ticket.url.split('/api/')[0];
    zendeskInfo.credentials.hdLoginUrl=`https://${ticket.ticket.brand.subdomain}.zendesk.com` //visible scm issue if subdomain is mapped then issues
    zendeskInfo.credentials.hdBrandLoginUrl=ticket.ticket.brand.url;
    console.log('currentUser',zendeskInfo.user)
    console.log('currentTicket',zendeskInfo.ticket);
    
    //custom solution for multi branding
    if (zendeskMetaObj.appId == 394508) {
      switch (zendeskMetaObj.installationId) {
        case 360002271937:
          zendeskInfo.credentials.hdLoginUrl='https://d3v-devopsintegration.zendesk.com';
          break;
        case 360005535917:
          zendeskInfo.credentials.hdLoginUrl='https://iqulsupport.zendesk.com';
          break;
        case 360005591711:
          zendeskInfo.credentials.hdLoginUrl='https://limeade.zendesk.com';//ryan.putnam@limeade.com
          break;
        case 360002259757:
          zendeskInfo.credentials.hdLoginUrl = 'https://thebigwordtechteam.zendesk.com'; //'https://wordsynk.zendesk.com';//martinb@thebigword.com
          break;
        case 7082548393117:
          zendeskInfo.credentials.hdLoginUrl = 'https://calero.zendesk.com'; //iain.harris@calero.com Max.Harris@mdsl.com
          break;
        case 9383002366107:
          zendeskInfo.credentials.hdLoginUrl = 'https://yourgi.zendesk.com'; //carlos.correa@destpet.com //https://destpet-it-help.zendesk.com
          break;
        case 360003599317:
          zendeskInfo.credentials.hdLoginUrl = 'https://farmtrace.zendesk.com'; //teike@ruma-vsm.nl //t.fransen@farmtrace.com
          break;
        case 7898379227933:
          zendeskInfo.credentials.hdLoginUrl = 'https://e-bateinternal.zendesk.com'; 
          break;
        case 8237197423644:
          zendeskInfo.credentials.hdLoginUrl = 'https://nuclyus.zendesk.com'; //alex.keelan@qemsolutions.com
          break;
        case 13523046628379:
          zendeskInfo.credentials.hdLoginUrl = 'https://support-toyotaforklift.zendesk.com'; //toyota Prod instance
          break;
        case 10083524475035:
          zendeskInfo.credentials.hdLoginUrl = 'https://supporttoyotaforklift1659551276.zendesk.com'; //toyota sbx instance
          break;
        case 16027258893073:
          zendeskInfo.credentials.hdLoginUrl = 'https://smartr365.zendesk.com'; //luke.murphy@smartr365.com
          break;
        case 14662548357911:
          zendeskInfo.credentials.hdLoginUrl = 'https://withalleo.zendesk.com'; //megan.nordwig@withalleo.com
          break;
        case 17528976536977:
          zendeskInfo.credentials.hdLoginUrl = 'https://nubreedhotels.zendesk.com'; //bartosz.kula@nubreedhotels.com
          break;
        case 15021817858196:
          zendeskInfo.credentials.hdLoginUrl = 'https://trisura.zendesk.com'; //randy.wong@trisura.com
          break;
        case 26033065277965:
          zendeskInfo.credentials.hdLoginUrl = 'https://fexalink.zendesk.com'; //steven.allen@fexa.io
          break;
        case 27664763686541:
          zendeskInfo.credentials.hdLoginUrl = 'https://socialladdersupport.zendesk.com'; //william@rkiapps.com , william@socialladderapp.com
          break;
        case 19678686772493:
          zendeskInfo.credentials.hdLoginUrl = 'https://sqldbmsupport.zendesk.com'; //artem.chigrinets@sqldbm.com
          break;
        case 6946352254363:
          zendeskInfo.credentials.hdLoginUrl = 'https://gomarquis.zendesk.com'; //zendesk@gomarquis.com
          break;
        case 30963876883732:
          zendeskInfo.credentials.hdLoginUrl = 'https://bsiconnectplus.zendesk.com'; //edwin.leech@bsigroup.com
          break;
        case 28082423061399:
          zendeskInfo.credentials.hdLoginUrl = 'https://ghvp1727816620.zendesk.com'; //greeta.tippineni@dbhdd.ga.gov
          break;
        case 360008291851:
          zendeskInfo.credentials.hdLoginUrl = 'https://passageways.zendesk.com'; //atavares@passageways.com , atavares@onboardmeetings.com
          break;
        case 31969355421851:
          zendeskInfo.credentials.hdLoginUrl = 'https://dealer-fx.zendesk.com'; //james_paulsen@dealer-fx.com
          break;
        case 15145244006684:
          zendeskInfo.credentials.hdLoginUrl = 'https://payoneer--mis.zendesk.com'; //infosysmanager@payoneer.com
          break;
        case 28079758913565:
          zendeskInfo.credentials.hdLoginUrl = 'https://moorepayhelpcentre.zendesk.com'; //angharad.whitburn@moorepay.co.uk
          break;
        // case 32431777837723:
        //   zendeskInfo.credentials.hdLoginUrl = 'https://franconnect1.zendesk.com'; //jason.williams@franconnect.com rizepoint
        //   break;
        default:
          break;
      }
    }

    //Custom app installed
    if (zendeskMetaObj.appId == 1108613 && zendeskMetaObj.installationId == 34398498614541) {
      zendeskInfo.credentials.hdLoginUrl = 'https://escribe.zendesk.com'; //atavares@passageways.com , atavares@onboardmeetings.com
    }
    
    //this is also working just don't want to try it yet.
    //console.log('branc out',document.location.ancestorOrigins["0"]);
    //if(document.location.ancestorOrigins && document.location.ancestorOrigins["0"]){
      //zendeskInfo.credentials.hdLoginUrl=document.location.ancestorOrigins["0"];
      //console.log('branc for rac',document.location.ancestorOrigins);
    //}
    
    // zendeskInfo.credentials={
    //   hdLoginUrl : "https://devopsintegration.zendesk.com",
    //   hdEmail:"support@devopsintegration.io",
    //   hdToken: "TKt5iZ35vHDGyd9TVQnPcvpxewb6lbwBOEGwaL1R",
    //   devOpsUrl:"https://dev.azure.com/devopsintegrationio",
    //   devOpsToken:"opwemda2aftj2n4rmjawzle5gd46fy65zny4ghoeaun2aghupwbq",
    //   requestType:"zendesk-devops"
    // }
    context.commit('setZendeskInfo',zendeskInfo); 
  },
  async getZdTicket(context){
    let zdTicket=await client.get('ticket');
    zdTicket=zdTicket.ticket;
    context.commit('setZdTicket',zdTicket); 
  },
  async getZdTicket_fields(context){
    let zdTicket_fields;
    let action=`ticketFields`;
    if(parentClient)
      zdTicket_fields=await parentClient.get(action);
    else 
      zdTicket_fields=await client.get(action);
    zdTicket_fields=zdTicket_fields.ticketFields;
    context.commit('setZdTicket_fields',zdTicket_fields); 
  },
  async getZdOrganization(context,organization_id){
    let zdOrganization=await client.get(`organization/${organization_id}`);
    context.commit('setZdOrganization',zdOrganization); 
  }
}

// mutations
// put sychronous functions for changing state e.g. add, edit, delete
const mutations = {
  setZendeskMetadata(state,payload){
    state.zdMetadata=payload;
  },
  setZendeskInfo(state,payload){
    state.zendeskInfo=payload;
    state.zendeskInfo.credentials.appId=state.zdMetadata.appId;
    state.zendeskInfo.credentials.installationId=state.zdMetadata.installationId;
  },
  setZdOrganization(state,payload){
    state.zdOrganization=payload;
  },
  setZdTicket_fields(state,payload){
    state.zdTicket_fields=payload;
  },
  setZdTicket(state,payload){
    state.zdTicket=payload;
  },
  setZendeskAttachments(state,payload){
    state.zendeskInfo.attachments=payload;
  },
  setZendeskLinkedItems(state,payload){
    state.zendeskInfo.linkedItems=payload;
  },
  setZendeskUser(state,payload){
    state.zendeskInfo.userInfo=payload;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
